import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

async function authHeaders(extra = {}) {
  const access_token = await AsyncStorage.getItem('access_token');
  return {Authorization: `Bearer ${access_token}`, ...extra};
}

async function baseUrl() {
  return AsyncStorage.getItem('url');
}

export function summarizeBoxCatalogImport(data) {
  if (!data || typeof data !== 'object') {
    return {success: false, message: 'Import failed — no response from the server.', errors: []};
  }
  if (data.valid) {
    const n = data.imported_count || 0;
    return {success: true, message: `Imported ${n} box${n === 1 ? '' : 'es'}.`, errors: []};
  }
  const errors = Array.isArray(data.errors) ? data.errors : [];
  const n = errors.length;
  return {
    success: false,
    message: `Import failed — nothing was saved. ${n} ${n === 1 ? 'row needs' : 'rows need'} fixing.`,
    errors,
  };
}

export function GetBoxTypesCount() {
  return async () => {
    try {
      const url = await baseUrl();
      const res = await axios.get(`${url}/box_types.json`, {headers: await authHeaders()});
      return res.data?.count ?? 0;
    } catch (error) {
      return null;
    }
  };
}

export function ClearBoxCatalog() {
  return async () => {
    try {
      const url = await baseUrl();
      const res = await axios.delete(`${url}/box_types/clear_all.json`, {headers: await authHeaders()});
      return res.data;
    } catch (error) {
      return error?.response?.data || {status: false};
    }
  };
}

export function ImportBoxCatalogCsv(file) {
  return async () => {
    const url = await baseUrl();
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await axios.post(`${url}/box_types/import.json`, formData, {
        headers: await authHeaders(),
      });
      return res.data;
    } catch (error) {
      return (
        error?.response?.data || {valid: false, row_count: 0, imported_count: 0, errors: []}
      );
    }
  };
}
